(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const config = {
    subtitle: [
      "We have your name. Below are the symbols on your coat of arms.",
      "We have your name. Below is your family crest.",
      "We have your name. Here's the symbols that will be on your crest."
    ]
  }

class SessionStorage {
    read(key){
        const raw = sessionStorage.getItem(key)
        try {
            return JSON.parse(raw)
        } catch (error) {
            return raw
        }
    }
    write(key, value){
        sessionStorage.setItem(key, JSON.stringify(value))
    }
}

  function scroll(){
    // document.getElementById('search-results-term').scrollIntoView({behavior: 'smooth'});
    document.getElementById( 'search-results-footer' ).scrollIntoView({behavior: 'smooth',  block: 'end' })
  }

  // Currently there is no implementation, not used but it is ready
  function hideProductCollections(){
    // SectionId should match with the section which is defined in themes/page.search.json
    const sectionId = 'shopify-section-template--15920944513206__36401817-051a-41aa-9b10-c7276bf5fd95'
    document.getElementById(sectionId).style.display = 'none'
  }
  
function showRandomNFImage(){
  document.getElementById(`search-results-img-nf`).style.display = 'block'
  
  const randomNumber = Math.random()
  if(randomNumber >= 0.5){
    document.getElementById(`search-results-img-nf-1`).style.display = 'none'
  } else {
    document.getElementById(`search-results-img-nf-2`).style.display = 'none'
  }
}

function setImg(imgSrc){
  const elId = 'search-results-img'
  const el = document.getElementById(elId)
  if(el) el.src = imgSrc
}

function setSubtitle(design){
  const elId = 'search-results-subtitle'
  const el = document.getElementById(elId)
  if(el) el.innerHTML = config.subtitle[design]
}

function setSearchTerm(term){
  const elId = 'search-results-term'
  const el = document.getElementById(elId)
  if(el) el.innerHTML = `Name: ${term}`
}



function renderImg(design, imgSrc){
  if(design === 0){
    showRandomNFImage()
  } else {
    setImg(imgSrc)
  }
}

function renderAdditionalElementsForDesign2(){
  const elId1 = 'search-results-type-2-additional'
  const el1 = document.getElementById(elId1)
  if(el1) el1.style.display = 'block'

  const elId2 = 'search-results-old-crest-additional'
  const el2 = document.getElementById(elId2)
  if(el2) el2.style.display = 'block'        
}

function render(data){
  const { result: { design, croppedImage: imgSrc }, _term: searchTerm } = data

  setSearchTerm(searchTerm)
  setSubtitle(design)
  renderImg(design, imgSrc)
  
  setTimeout(() => {
    document.getElementById(`search-results-loader`).style.display = 'none'
    document.getElementById(`search-results`).style.display = 'block'
  
    switch (design) {
      case 0:
        break;
        
      case 1: 
        break;
        
      case 2: 
        renderAdditionalElementsForDesign2();
        break;
    }

    setTimeout(() => {
       scroll()
    }, 500)

  }, 1000);


  console.log('rendering')
}

function isCached (term, results){
  if(!results) return false
  if(term === results._term) return true
  return false
}

async function fetchData(term){
  const url = `https://crestsandarms-search.fly.dev/search?term=${term}`
  const response = await fetch(url)
  const data = await response.json()
  return data
}

async function search() {
  const sessionStorageService = new SessionStorage()
  
  const term = sessionStorageService.read('crestsandarms_sterm')
  const results = sessionStorageService.read('crestsandarms_sres')

  const isSameRequest = isCached(term, results)
  console.log(0, { term, results, isSameRequest })
  
  if(isSameRequest) {
    console.log(1, 'same req just render')
    return render(results)
  }

  const data = await fetchData(term)
  console.log('@@@@@')
  console.log(2, `fetched for ${term}`, data)
  sessionStorageService.write('crestsandarms_sres', data)
  console.log(3, 'wrote to session')
  return render(data)
}

document.addEventListener('DOMContentLoaded', async ()=>{
    await search()
})

  } catch(e) { console.error(e); }
})();
})();
